'use client';
import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../../helpers/use-debounce';
import { fetchFormationLevels } from './fetch-formation-levels';

type Props = {
  isOpen: boolean;
  term: string | null;
};

export const useFormationLevelsAutocomplete = (props: Props) => {
  const { isOpen, term } = props;

  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['formation-levels-autocomplete', termDebounced] : null),
    ([_, term]) => fetchFormationLevels(client, term)
  );
};
